import customAxios from "../../customAxios";

import { TOTAL_FACTOR_PRICE_FOR_DRIVER } from "../../routes";

type IData = {
  driverId: string;
  factorList: string[];
  startAt: string;
  // endAt?: string;
};

const totalFactorPriceForDriver = async (formData: IData) => {
  try {
    return (
      await customAxios.post(
        TOTAL_FACTOR_PRICE_FOR_DRIVER + "/" + formData.driverId,
        {
          factorList: formData.factorList,
          startAt: formData.startAt,
          // endAt: formData.endAt,
        }
      )
    ).data;
  } catch (error: unknown) {
    console.error({ TOTAL_FACTOR_PRICE_FOR_DRIVER: error });
    return false;
  }
};

export default totalFactorPriceForDriver;
